// Actions
import { TypedAction } from "@ms/uno-fluxcore/lib/local/actions/Action";
import { ActionType } from "../ActionType";
export class ViewRenderAction extends TypedAction(ActionType.ViewRenderAction) {
    isLoggingEnabled() {
        /**
         * This action is handled and logged via the performance marker API from
         * within the performance collection store so we don't need to log them here.
         */ return false;
    }
    constructor(viewId, state, extraData){
        super(), this.viewId = viewId, this.state = state, this.extraData = extraData;
    }
}
export class StartTrackedInteractionAction extends TypedAction(ActionType.StartTrackedInteractionAction) {
    isLoggingEnabled() {
        return false;
    }
    constructor(name, startTime, targetViewId, completionStrategy, extraData){
        super(), this.name = name, this.startTime = startTime, this.targetViewId = targetViewId, this.completionStrategy = completionStrategy, this.extraData = extraData;
    }
}
export class CompleteTrackedInteractionAction extends TypedAction(ActionType.CompleteTrackedInteractionAction) {
    isLoggingEnabled() {
        return false;
    }
    constructor(targetViewId){
        super(), this.targetViewId = targetViewId;
    }
}
